import { http } from "./api";
import { log } from "./logger";

function urlBase64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export const isPushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function registerSW() {
  if (!isPushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    return reg;
  } catch (e) {
    log.warn("SW registration failed", e);
    return null;
  }
}

export async function getPushStatus() {
  if (!isPushSupported()) return { supported: false, granted: false, subscribed: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return {
    supported: true,
    granted: Notification.permission === "granted",
    subscribed: !!sub,
  };
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error("Notifications non supportées sur ce navigateur");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission refusée");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerSW());
  if (!reg) throw new Error("Service Worker indisponible");
  await navigator.serviceWorker.ready;
  const { data } = await http.get("/push/vapid-public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  await http.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribePush() {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await http.post("/push/unsubscribe", { subscription: sub.toJSON() });
  await sub.unsubscribe();
}

export async function testPush() {
  await http.post("/push/test");
}
